import React from 'react';
import {FaTwitter ,FaInstagram , FaLinkedinIn, FaYoutube} from "react-icons/fa";

const SocialShare = [
    {Social: <FaYoutube /> , link: 'https://www.youtube.com/@auzzzy1111'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/auz1111/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/auz1111/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/in/auzheal/'},
]

const FooterTwo = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div className="footer-style-2 ptb--30 bg_color--6">
            <div className="wrapper plr--50 plr_sm--20">
                <div className="row align-items-center justify-content-between">
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="inner">
                            <div className="logo text-center text-sm-left mb_sm--20">
                                <a href="/">
                                    <img src="/assets/images/logo/digital-thoughts-media-icon.png" alt="Logo images"/>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="inner text-center">
                            <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                                {SocialShare.map((val , i) => (
                                    <li key={i}><a href={`${val.link}`} target='_blank' rel='noopener noreferrer'>{val.Social}</a></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                        <div className="inner text-lg-right text-center mt_md--20 mt_sm--20">
                            <div className="text">
                                <p>© {currentYear} Digital Thoughts Media. All Rights Reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FooterTwo;